<template>
  <div>
    <el-dialog
        :title=resource.课件标题
        :visible.sync="dialogVisible"
        :width=windowWidth
        @close="closed"
        :top=windowTop
        >
        <div class="preview">
            <iframe allowfullscreen="true" :src= resourceUrl frameborder="0"></iframe>
        </div>
        <div slot="footer" class="dialog-footer">
            <span class="qrCode"><vue-qr :margin="0" :logoSrc="imageUrl" :text ='resourceUrl' :size=qrSize></vue-qr></span>
            <span class="text" >手机平板 <br> 扫码访问</span>
            <el-button type="primary" style="margin-right: 15px;" @click="copyLink">复制课件链接</el-button>
            <el-button v-if="resource.操作视频地址" type="primary" @click="showVideo = true">课件操作视频</el-button>
        </div>
    </el-dialog>
    <videoDisplay v-if="showVideo" :video_url="resource.操作视频地址" @videoClosed="videoClosed"/>
  </div>
</template>

<script>
import vueQr from 'vue-qr'
import videoDisplay from './videoDisplay.vue'
export default {
  name: '',
  props: ['resource'],
  data () {
    return {
        dialogVisible:false,
        resourceUrl: 'https://www.netpad.net.cn/presentationEditor/presentationPlay.html#share/' + this.resource.课件分享地址,
        imageUrl: require("../assets/logo.png"),
        showVideo:false,
        windowTop:window.innerWidth < 450 ? '27vh':'11vh',
        windowWidth:window.innerWidth < 450 ? '66vh':'840px',
        qrSize:window.innerWidth < 450 ? 30:100,
    }
  },
  components: {vueQr,videoDisplay},
  created () {},
  mounted () {
    this.dialogVisible = true

  },
  methods: {
    closed(){
        this.dialogVisible = false
        this.$emit('closed')
    },
    async copyLink() {
        try {
            await navigator.clipboard.writeText(this.resourceUrl);
            this.$message({
                message: '复制成功',
                type: 'success'
            });
        } catch (err) {
            console.error('出现错误: ', err);
        }
    },
    videoClosed(){
        this.showVideo = false
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .el-dialog{
    border-radius: 5px;
}
::v-deep .el-dialog__header {
    border-bottom: 1px solid #ccc;
    padding: 16px 24px;
    font-weight: 600;
    .el-dialog__title{
        font-size: 24px;
        color: rgba(0, 0, 0, .85);
        font-weight: 500;
    }
}

::v-deep .el-dialog__body {
    padding: 20px;
}

::v-deep .el-dialog__footer {
    text-align: left;
    padding:0 15px 15px;
    .dialog-footer {
        display: flex;
        align-items: flex-end;
    }
}

.preview {
    height: 450px;
    border: 1px solid #ccc;

    iframe {
        width: 100%;
        height: 100%;
        border: 0;
    }
}

.qrCode {
    display: inline-block;
    width: 100px;
    height: 100px;
    margin-right: 10px;
}
.text{
    font-size: 12px;
    margin-right: 20px;
    color:#aaa
}
@media screen and (max-width: 450px) {
    ::v-deep .el-dialog {
        transform: rotate(90deg) ;
        margin: 0 auto;
        height: 100vw;
    }
    .preview {
        height: 80vw;
    }
    ::v-deep .el-dialog__header {
        padding: 5px 24px;
        .el-dialog__title{
            font-size: 3vw;
        }
        .el-dialog__headerbtn{
            top: 7px;
        }
    }

    ::v-deep .el-dialog__body {
        padding: 2px 5px;
    }

    ::v-deep .el-dialog__footer {
        padding:0 15px 0;
    }
    ::v-deep .el-button{
        font-size: 2vw;
        padding: 6px 10px;
    }
    .qrCode {
    width: 30px;
    height: 30px;
    margin-right: 10px;
}
.text{
    font-size: 1.5vw;
}
}
</style>
